/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum BundleStatus {
  Open = 'open',
  Sent = 'sent',
  Closed = 'closed'
}
